import React from 'react'
import axiosClient from '../global/Globalapi'

const Productpage = ({product,onviewproduct}) => {
    const baseURL = axiosClient.defaults.baseURL;
    
  return (
    <div className="w-full max-w-xs rounded-2xl overflow-hidden bg-white p-4 shadow-md hover:shadow-xl transition-shadow duration-300">
      <div className="w-full h-80 overflow-hidden rounded-xl group">
        <img
          src={`${baseURL}/uploads/${product.image_url}`}
          alt={product.product_name}
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      <h2 className="text-lg font-semibold mt-4 capitalize text-center">
        {product.product_name}
      </h2>
      {/* <p className="text-sm text-gray-500 text-center mb-4">-</p> */}
      <div className='flex justify-center'>
       <button className="px-4 py-2 bg-red-700 text-white rounded-md  hover:bg-orange-800 transition duration-200 transform hover:scale-105"
        onClick={onviewproduct}
       >
        View Product
       </button>
      </div>
    </div>
  );
}

export default Productpage
